import { FormControl } from '@angular/forms';
import { ListViewDataBase } from '@examdojo/core/list-view';
import { IRowNode, ValueGetterFunc } from 'ag-grid-community';
import { ExternalFilterType } from '../list-view.model';
import {
  createCheckboxFilterFormCtrl,
  ListViewExternalCheckboxFilterValue,
} from './list-view-checkbox-filter.component';
import { createRangeFilterFormCtrl, ListViewExternalRangeFilterValue } from './list-view-range-filter.component';

export interface BaseExternalFilterColumn<TData = ListViewDataBase> {
  colId: string;
  filter: ExternalFilterType;
  formCtrl: FormControl;
  label: string;
  options?: Array<string | number>;
  doesExternalFilterPassFunc: ExternalFilterColDef<TData>['doesExternalFilterPassFunc'];
  filterValueGetter: ValueGetterFunc<TData>;
}

export interface CheckboxExternalFilterColumn extends BaseExternalFilterColumn {
  filter: ExternalFilterType.Checkbox;
  formCtrl: ReturnType<typeof createCheckboxFilterFormCtrl>;
  options?: string[];
}

export interface RangeExternalFilterColumn extends BaseExternalFilterColumn {
  filter: ExternalFilterType.Range;
  formCtrl: ReturnType<typeof createRangeFilterFormCtrl>;
  options?: number[];
  subText?: string;
  step: number;
}

export type ExternalFilterColumn = CheckboxExternalFilterColumn | RangeExternalFilterColumn;
export type ExternalFilterValue = ListViewExternalCheckboxFilterValue | ListViewExternalRangeFilterValue;

export function createFilterColumn(
  externalFilterColDef: ExternalFilterColDef,
  colId: string,
  filterValueGetter: ValueGetterFunc<ListViewDataBase>,
): ExternalFilterColumn {
  switch (externalFilterColDef.filter) {
    case ExternalFilterType.Checkbox:
      return {
        colId,
        filter: ExternalFilterType.Checkbox,
        doesExternalFilterPassFunc: externalFilterColDef.doesExternalFilterPassFunc,
        formCtrl: createCheckboxFilterFormCtrl(),
        label: externalFilterColDef.label,
        filterValueGetter,
      };
    case ExternalFilterType.Range:
      return {
        colId,
        filter: ExternalFilterType.Range,
        doesExternalFilterPassFunc: externalFilterColDef.doesExternalFilterPassFunc,
        formCtrl: createRangeFilterFormCtrl(),
        label: externalFilterColDef.label,
        subText: externalFilterColDef.subText,
        step: externalFilterColDef.step ?? 1,
        filterValueGetter,
      };
  }
}

export interface ExternalFilterColDef<TData = ListViewDataBase> {
  label: string;
  filter: ExternalFilterType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  doesExternalFilterPassFunc: (value: any) => (node: IRowNode<TData>) => boolean;
  step?: number;
  subText?: string;
}
